import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e168504"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "html2pdf__page-break" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("section", {
        class: _normalizeClass(["pdf-item pdf-container", [
        _ctx.noMargin ? 'no-margin' : '',
        `pdf-container-page-${_ctx.pdfKey}`
      ]]),
        style: {"height":"1100px"}
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2),
      _hoisted_1
    ]),
    _hoisted_2
  ], 64))
}